__turbopack_context__.v({
  "activation": "Activation-module-scss-module__IEJzIW__activation",
  "cancel": "Activation-module-scss-module__IEJzIW__cancel",
  "ctas": "Activation-module-scss-module__IEJzIW__ctas",
  "searchContainer": "Activation-module-scss-module__IEJzIW__searchContainer",
  "searchDiv": "Activation-module-scss-module__IEJzIW__searchDiv",
  "share": "Activation-module-scss-module__IEJzIW__share",
});
